webpackJsonp([1],{

/***/ "+dqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/iHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_imgs_com0_jpg__ = __webpack_require__("Y7em");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_imgs_com0_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_imgs_com0_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgs_com1_jpg__ = __webpack_require__("jAAr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgs_com1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_imgs_com1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_imgs_com2_jpg__ = __webpack_require__("aRUm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_imgs_com2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_imgs_com2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgs_com3_jpg__ = __webpack_require__("rP+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgs_com3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_imgs_com3_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_imgs_com4_jpg__ = __webpack_require__("l7y+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_imgs_com4_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_imgs_com4_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import com0 from "./components/com0";
import com1 from "./components/com1";
import com2 from "./components/com2";
import com3 from "./components/com3";
import com4 from "./components/com4";*/





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      activeIndex: 0,
      currentCom: "com0",
      imgArr: [__WEBPACK_IMPORTED_MODULE_0__components_imgs_com0_jpg___default.a, __WEBPACK_IMPORTED_MODULE_1__components_imgs_com1_jpg___default.a, __WEBPACK_IMPORTED_MODULE_2__components_imgs_com2_jpg___default.a, __WEBPACK_IMPORTED_MODULE_3__components_imgs_com3_jpg___default.a, __WEBPACK_IMPORTED_MODULE_4__components_imgs_com4_jpg___default.a],
      list: ["边缘计算<br>智能终端", "固定式AI<br>环境监测站", "车载式AI<br>环境监测站", "便携式AI<br>环境监测站", "无人机机载式<br>AI环境监测站"]
    };
  },

  methods: {
    handleClick: function handleClick(index) {
      this.activeIndex = index;
      this.currentCom = "com" + index;
    }
  },
  watch: {}
});

/***/ }),

/***/ "159u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xiaocx.4f1f1f7.jpg";

/***/ }),

/***/ "1gzZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.4220319.png";

/***/ }),

/***/ "25Qv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "34KM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3F6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com0_vue__ = __webpack_require__("XZZx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_49cbc458_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com0_vue__ = __webpack_require__("Fd3U");
function injectStyle (ssrContext) {
  __webpack_require__("JpfX")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com0_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_49cbc458_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com0_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3h9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      infos: "",
      timing: "",
      sponsors: ''
    };
  }
});

/***/ }),

/***/ "4r9Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5E5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com4_vue__ = __webpack_require__("SEo8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_82efe052_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com4_vue__ = __webpack_require__("9/nU");
function injectStyle (ssrContext) {
  __webpack_require__("+dqH")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_82efe052_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7+Nz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc1.d8acaa3.png";

/***/ }),

/***/ "7NPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('e-header'),_vm._v(" "),_c('div',{staticClass:"contentWrap"},[_c('router-view')],1),_vm._v(" "),_c('e-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9/nU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comWrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"comItemWrap"},[_c('div',{staticClass:"comItemTiitle"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"comItemContent",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9HGo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc4.3d9913e.png";

/***/ }),

/***/ "AW8I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"headerWrap"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"tab-itemee"},[_c('li',[_c('router-link',{attrs:{"to":"/index"}},[_c('span',{staticClass:"navFont"},[_vm._v("首页")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/solution"}},[_c('span',{staticClass:"navFont"},[_vm._v("解决方案")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/product"}},[_c('span',{staticClass:"navFont"},[_vm._v("产品中心")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_c('span',{staticClass:"navFont"},[_vm._v("关于我们")])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoWrap"},[_c('img',{staticClass:"logoImg",attrs:{"src":__webpack_require__("1gzZ"),"alt":"logo"}}),_vm._v(" "),_c('div',{staticClass:"titleSty"},[_vm._v("深圳市鑫安智能科技有限公司")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Aoun":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABoCAYAAACXMyzgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAULSURBVHhe7ZgNbuYgDET39j1JT9KT9CTdHWktWd4BDJgfZ/OkkapAArwQJ19//bwc45V/kFf+QV75B3nlHySl/O/v75+vr69/guOZuFY+RH58fITlxhtzlXwmbUU+Pz//jniW4/JRLpigXTl5I47KZzJO5QTb5UfX8ujsZKt8tthbs4Nt8tkCb89qlss//UKdDea/iqXy2WKyZgVL5N/+Uh1NNEvks4k/JZGEy2cTflqiCJXPJvrURBAmn03w6ZklRD6b2P+SGablP/XLxpuZf1VPyY/4ASU/YjL/GBtlSj6bSG/0zmHtGTL6K3hYPv4PzibSmyfIR0ZuwLB8NoFVibrRq9PLkHw2MIuGtXsDPO8EcPpG9bBUvpSU2Zep0LoOYMcjgzXVbnAP3fIxOBu0FMCO9+SGsqOpzaen9nfLZwPWMnLOTdEfBEJrM3jpkj+yA3tLzmyJigwTD1oevLu/Sz4bKDqgt7RFB3IZPfPycJ3802G7dmQzeHDLHyk52cIYLYOe0uOWzwZ4Uhiz5a9FuHxw00vTE7ZLWb/etHjMzh+94ezlGlViWxyRv+LJGJ0jg/UbSQuX/MiXrYa1I7U2Fl02WHspDNZvNKycaVzy2YVnghcZe5nhGNjxZcVg/WZTI1y+wNpq0bD2yLA6D1jf2dS4Tv7s550njFVPW40jZYdFYG2RKfHK/wNrG02pvJRY9RVW4pHy5cW9ip6npEYa+d4F7yCN/F5prE3KB2vT2UUK+cD79SKwNqTWJtnF9fI1rN1GYG1I6ya2fk1GcrV8+8JjfWwE1ubJTrbK7xkMGZEv57A2T3bi9YF+NVzyR75/NaxksGOCPe7JCJhDTWSplHnl201occkH7OK1WFibPlY77kkvPU+zxXtui2Xy7SOndzr+ru18YNta8cLE2R3O5qbXc718xD52uq1UygTWVor3S2fkHDtPkEI+otGTLi1A8C4Q8SL9ce0e7Ly9c2vhls8eRU8srI+NwNpsvPT2t+gnwCPfg1s+YIN4ovHcRNmZUYsUcbVSI31kbIYtQbV42CLfLqhHaquvh1rf2vUZrB+Lhy75PXfepvbyLUVgbZIWes4WLV7PT46xczwO7FpLdMkHbDBvLKyPDagtuEWtn6cNY1ukrRQv3fIBG9AbC+tjU+vXotRPdn2N0rlynKWH7fIRjfcrCpSO1yj185zfOpelhyH5M7VfYh9n70vYHmvVV+lnWbHzvbVeGJIP2OAjsbA+rdSo9am1yQbDTbLIeTa9DMsHbAIz0Yw8XTgHu0+ir8F2pT5Xo59CC66jzyv183CVfAkWL7JKi5V4ypWEwfpJbGkEbDx2Yz1MyQd2IjenhL3BTLqg+0lGmZYP2IRuzQzR1wuR3/Pon85oiWBrrD0hHkLkAzux29MDOx+ZJUw+0F8XWVJ7Ekrrmd3xQqh8kKkEjSRKPAiXD9ikn5JIlsgHbOKZE7njhWXyBbaQbFnFcvmtX6i3Z8WOF5bLF9jCbg4+HFazTb7AFnpbdrFdPri1FO3miHzhlt8EO0oM46h84dSTcJor5GtW34ibuE6+JqosrfxcnOFq+RYmluVUDe/lkfJr/6m8iVTyvWUoC6nko3Yz2TZZSCUfMNk2WXjlHySd/FbpyfKyBenkAyZdkolX/kFe+Qd5lPwsv2yFlPIBk5+NV/5B0sq3n5zZSg5IKx9o+RlJLR9kFQ/Sy8/MK/8gr/yDvPKP8fPzGx9suZeMN79qAAAAAElFTkSuQmCC"

/***/ }),

/***/ "BUbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: [],
  data: function data() {
    return {
      info: "",
      list: [{
        title: "指标因子",
        content: "恶臭十参数：臭气浓度OU、TVOC、硫化氢H2S、氨气NH3、三甲胺C₃H₉N、甲硫醇CH₃SH、甲硫醚C₂H₆S、二甲二硫C₂H₆S₂、苯乙烯C₈H₈、二硫化碳CS2<br>" + "气象类型：微气象五参(风速、风向、温度、湿度、气压)、噪声"
      }, {
        title: "应用场景",
        content: "固定式、车载式、便携式手提箱、无人机机载"
      }, {
        title: "方案内容",
        content: "建设基于多种感知技术、覆盖多种应用场景、多项数据融合，实时交互分析研判指挥治理的恶臭在线监测网络。<br>" + "实现秒级数据和米级范围监测采集，智能化数据分析 + 多证据耦合分析研判，精准判断恶臭污染事件特性，多级预警告警处理机制，做到精准溯源、全自动流程治理。最终达到有效解决恶臭污染、恶臭投诉的目的。"
      }]
    };
  },
  created: function created() {},

  components: {},
  methods: {}
});

/***/ }),

/***/ "ByPn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solutionWrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentWrapFist"},[_c('div',{staticClass:"nav-wrap"},[_c('div',{staticClass:"nav-inner"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"nav-item",class:{active:index==_vm.activeIndex},domProps:{"innerHTML":_vm._s(item)},on:{"click":function($event){return _vm.handleClick(index)}}})}),0)])]),_vm._v(" "),_c('div',{staticClass:"imgConWrap"},[_c(_vm.currentCom,{tag:"component"})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageBgSty"},[_c('div',{staticClass:"pageTitle"},[_vm._v("环境空气质量监测解决方案")]),_vm._v(" "),_c('div',{staticClass:"pageTitleTips"},[_vm._v("基于物联网、AI智能识别、大数据及云计算等技术，形成环境空气质量监测解决方案")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CNw4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc3.6a9e975.png";

/***/ }),

/***/ "ETTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com1_vue__ = __webpack_require__("x+S9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_23184c45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com1_vue__ = __webpack_require__("arQ9");
function injectStyle (ssrContext) {
  __webpack_require__("25Qv")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_23184c45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EWIa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EgM8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eyra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comWrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"comItemWrap"},[_c('div',{staticClass:"comItemTiitle"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"comItemContent",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F8ay":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FMR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fd3U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comWrap"},[_c('div',{staticClass:"comItemWrap"},[_c('div',{staticClass:"imgComWrap"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("Y7vU"),"alt":""}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G2h3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_solution_vue__ = __webpack_require__("zjiE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5aa8c775_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_solution_vue__ = __webpack_require__("ByPn");
function injectStyle (ssrContext) {
  __webpack_require__("PaU/")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_solution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5aa8c775_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_solution_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gizm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_bg.324a3d6.png";

/***/ }),

/***/ "HV4J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc2.5cc2896.png";

/***/ }),

/***/ "If12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_product_vue__ = __webpack_require__("/iHE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ec8ace78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_product_vue__ = __webpack_require__("RMvW");
function injectStyle (ssrContext) {
  __webpack_require__("PeEc")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ec8ace78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JpfX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KNS7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com2_vue__ = __webpack_require__("BUbz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_691c8b22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com2_vue__ = __webpack_require__("igzg");
function injectStyle (ssrContext) {
  __webpack_require__("EgM8")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_691c8b22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("YkRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_stylus_index_styl__ = __webpack_require__("34KM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_reset_css__ = __webpack_require__("EWIa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// element

//已用
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Carousel"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Scrollbar"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["CarouselItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Row"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Col"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Collapse"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["CollapseItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Button"]);

//未用
/*
 Vue.use(Autocomplete)
 Vue.use(MenuItemGroup)
 Vue.use(InputNumber)
 Vue.use(Switch)
 Vue.use(ButtonGroup)
 Vue.use(Loading.directive)
 Vue.use(Pagination)
 Vue.use(Table)
 Vue.use(TableColumn)
 Vue.use(Icon)
Vue.use(Tabs)
Vue.use(TabPane)
 Vue.use(Menu)
 Vue.use(RadioGroup)
 Vue.use(RadioButton)
 Vue.use(Submenu)
 Vue.use(Input)
 Vue.use(MenuItem)
 Vue.use(Checkbox)
 Vue.use(CheckboxGroup)
 Vue.use(DatePicker)
 Vue.use(Breadcrumb)
 Vue.use(BreadcrumbItem)
 Vue.use(Dialog)
 Vue.use(Form)
 Vue.use(FormItem)
 Vue.use(Option)
 Vue.use(OptionGroup)
 Vue.use(Select)
 Vue.use(Dropdown)
 Vue.use(DropdownMenu)
 Vue.use(DropdownItem)
 Vue.use(Tag)
 Vue.use(Tree)
 Vue.use(Radio)
 Vue.use(Upload)

 Vue.use(TimeSelect)
 Vue.use(TimePicker)
 Vue.use(Popover)
 Vue.use(Tooltip)
 Vue.use(Alert)
 Vue.use(Slider)

 Vue.prototype.$msgbox = MessageBox
 Vue.prototype.$confirm = MessageBox.confirm
 Vue.prototype.$prompt = MessageBox.prompt
 Vue.prototype.$alert = MessageBox.alert

 Vue.prototype.$loading = Loading.service
 Vue.prototype.$notify = Notification

*/

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"];

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

/***/ }),

/***/ "O1Lr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: [],
  data: function data() {
    return {
      info: "",
      list: [{
        title: "指标因子",
        content: "扬尘因子：PM1.0、PM2.5、PM10、TSP、噪声等<br>" + "气象类型：微气象五参(风速、风向、温度、湿度、气压)、噪声<br>" + "AI智能识别算法：工地场地扬尘识别、工地出入口道路破损识别、渣土车未密闭运输识别、裸土未覆盖识别、车辆未清洗识别、工地物料乱堆放识别、工程车冒黑烟识别"
      }, {
        title: "应用场景",
        content: "固定式、车载式、便携式手提箱、无人机机载"
      }, {
        title: "方案内容",
        content: "建设基于多种感知技术、覆盖多种应用场景、多项数据融合，实时交互分析研判指挥治理的扬尘在线监测网络。<br>" + "实现秒级数据和米级范围监测采集，智能化数据分析 + 多证据耦合分析研判，精准判断扬尘污染事件特性，多级预警告警处理机制，做到精准溯源、全自动流程治理。最终达到有效解决扬尘污染、扬尘投诉、区域扬尘管控/指标质量提升的目的。"
      }]
    };
  },
  created: function created() {},

  components: {},
  methods: {}
});

/***/ }),

/***/ "OT2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com3_vue__ = __webpack_require__("O1Lr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4f90cd6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com3_vue__ = __webpack_require__("Eyra");
function injectStyle (ssrContext) {
  __webpack_require__("RGdu")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_com3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4f90cd6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_com3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PaU/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PeEc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RGdu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RMvW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productWrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentWrapFist"},[_c('div',{staticClass:"nav-wrap"},[_c('div',{staticClass:"nav-inner"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"nav-item",class:{active:index==_vm.activeIndex},domProps:{"innerHTML":_vm._s(item)},on:{"click":function($event){return _vm.handleClick(index)}}})}),0)])]),_vm._v(" "),_c('div',{staticClass:"imgConWrap"},_vm._l((_vm.imgArr),function(item,index){return (index==_vm.activeIndex)?_c('img',{key:index,staticClass:"img_content",attrs:{"src":item,"alt":""}}):_vm._e()}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageBgSty"},[_c('div',{staticClass:"pageTitle"},[_vm._v("产品中心")]),_vm._v(" "),_c('div',{staticClass:"pageTitleTips"},[_vm._v("基于传感器技术、物联网技术、音视频技术、AI智能识别技术，形成新一代大气监测智能化产品")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SEo8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: [],
  data: function data() {
    return {
      info: "",
      list: [{
        title: "指标因子",
        content: "温室气体指标因子：CO₂、CH₄、H2O、N2O、CO、H2、 NH3等<br>" + "气象类型：微气象五参(风速、风向、温度、湿度、气压)"
      }, {
        title: "应用场景",
        content: "固定式、车载式、便携式手提箱、无人机机载"
      }, {
        title: "方案内容",
        content: "建设基于多种感知技术、覆盖多种应用场景、多项数据融合，实时交互分析研判的温室气体在线监测网络。<br>" + "实现秒级数据和米级范围监测采集，智能化数据分析 + 多证据耦合分析研判，精准判断温室气体排放特性。"
      }]
    };
  },
  created: function created() {},

  components: {},
  methods: {}
});

/***/ }),

/***/ "TKJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("3h9H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ff5a475_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("iI4Y");
function injectStyle (ssrContext) {
  __webpack_require__("4r9Y")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ff5a475_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tvie":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "Ukqi":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "WW92":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc5.03d0d08.png";

/***/ }),

/***/ "XZZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: [],
  data: function data() {
    return {
      info: "",
      list: [{
        title: "指标因子定制",
        content: "标准六参/七参/定制：PM2.5、PM10、SO2、NO2、CO、O3、TVOC、HCN、HF、HCl、<br>" + "扬尘类型：PM1.0、 PM2.5、PM10、TSP<br>" + "恶臭类型：TVOC、恶臭OU、H2S、NH3、甲硫醚、甲硫醇、二甲二硫、二硫化碳、苯乙烯、三甲胺<br>" + "温室气体类型：CO₂、CH₄、H2O、N2O、CO、H2、 NH3<br>" + "气象类型：微气象五参(风速、风向、温度、湿度、气压)、噪声<br>"
      }, {
        title: "结构定制",
        content: "固定式、车载式、便携式手提箱、无人机机载"
      }, {
        title: "产品功能定制",
        content: "4路1080P音视频功能、双向对讲/单向喊话<br>" + "多种供电方式：市电/太阳能/车载/可充电电池、<br>" + "低功耗、超长待机<br>" + "宽幅电源输入、断电保护功能<br>" + "告警联动图片抓拍、告警视频上传<br>" + "长时间告警、多次告警自动生成处理工单<br>"
      }]
    };
  },
  created: function created() {},

  components: {},
  methods: {}
});

/***/ }),

/***/ "XvRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerWrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"police",on:{"click":function($event){return _vm.toMiit()}}},[_vm._v("粤ICP备2022003579号")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerNav"},[_c('div',[_c('div',{staticStyle:{"padding":"5px 0"}},[_c('a',{staticStyle:{"color":"#333"},attrs:{"href":"javascript:;"}},[_vm._v("联系方式")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5px 0"}},[_c('a',{staticStyle:{"color":"#333","font-size":"12px"},attrs:{"href":"javascript:;"}},[_vm._v("联系电话：0755-26401941\n          18666821228")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5px 0"}},[_c('a',{staticStyle:{"color":"#333","font-size":"12px"},attrs:{"href":"javascript:;"}},[_vm._v("企业邮箱：\n          22031203@163.com")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5px 0"}},[_c('a',{staticStyle:{"color":"#333","font-size":"12px"},attrs:{"href":"javascript:;"}},[_vm._v("公司地址：\n          深圳市宝安区新安街道大浪社区28区新安三路一巷24号汇聚宝安湾智创园B栋506")])])]),_vm._v(" "),_c('div',{staticClass:"ma_wrap"},[_c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":__webpack_require__("ZXXI")}})]),_vm._v(" "),_c('div',{staticClass:"bottom_tips"},[_vm._v("扫一扫 关注公众号")])]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"height":"120px"},attrs:{"src":__webpack_require__("159u")}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y7em":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/com0.3a2c983.jpg";

/***/ }),

/***/ "Y7vU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/com5.a1ad775.jpg";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_home_vue__ = __webpack_require__("zKIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_solution_solution_vue__ = __webpack_require__("G2h3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_product_product_vue__ = __webpack_require__("If12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_about_about_vue__ = __webpack_require__("TKJ5");







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: "active",
  // mode:"history",//去掉#
  routes: [{
    path: '/index',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_home_vue__["a" /* default */]
  }, {
    path: '/solution',
    component: __WEBPACK_IMPORTED_MODULE_3__views_solution_solution_vue__["a" /* default */]
  }, {
    path: '/product',
    component: __WEBPACK_IMPORTED_MODULE_4__views_product_product_vue__["a" /* default */]
  }, {
    path: '/about',
    component: __WEBPACK_IMPORTED_MODULE_5__views_about_about_vue__["a" /* default */]
  },
  //直接跳转到home页
  {
    path: '/',
    redirect: '/index'
  }]
}));

/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("t3m8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6f3264a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("7NPJ");
function injectStyle (ssrContext) {
  __webpack_require__("cUbD")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6f3264a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZXXI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/erweima.d1e74d4.jpg";

/***/ }),

/***/ "aKrY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.663cd21.png";

/***/ }),

/***/ "aRUm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/com2.e4e9c10.jpg";

/***/ }),

/***/ "arQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comWrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"comItemWrap"},[_c('div',{staticClass:"comItemTiitle"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"comItemContent",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cUbD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dQCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("oh/k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a5f9f9ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("XvRa");
function injectStyle (ssrContext) {
  __webpack_require__("FMR/")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a5f9f9ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hxP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("mEum");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_699263ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("AW8I");
function injectStyle (ssrContext) {
  __webpack_require__("F8ay")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_699263ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iI4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regardsWrap"},[_c('img',{attrs:{"src":__webpack_require__("Gizm"),"width":"100%","height":"500","alt":""}}),_vm._v(" "),_c('div',{staticClass:"about_content"},[_c('div',{staticClass:"about_inner"},[_c('div',{staticClass:"text_wrap"},[_c('p',{staticClass:"about_title"},[_vm._v("公司简介")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"text_left"}),_vm._v("深圳市鑫安智能科技有限公司成立于2012年10月，位于深圳市宝安区，是一家专注于物联网技术、大数据技术、人工智能技术研发，聚焦智能物联领域和智慧环保领域的高新技术企业。公司拥有行业领先的整体解决方案，包括智慧环保大气监测软硬件产品定制开发方案，环境空气质量监测系统解决方案，恶臭监测解决方案，扬尘监测解决方案，温室气体监测解决方案等，智能化大气监测硬件产品覆盖固定式安装、车载式安装、便携式、无人机机载式安装等多个应用场景，融合了传感器技术、音视频技术、AI人工智能识别技术、智能算法技术，配合基于SaaS架构的信息化智慧环保平台、公众号、小程序，形成了整套端到端的智慧环保整体解决方案。")]),_c('br'),_vm._v(" "),_c('p',[_c('span',{staticClass:"text_left"}),_vm._v("公司正在努力成为智能物联和智慧环保大气监测领域国内领先的整体解决方案提供商和运营服务商。")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"about_building"},[_c('img',{staticClass:"building",attrs:{"src":__webpack_require__("w/Kr"),"alt":""}})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"about_title"},[_vm._v("地图位置")]),_vm._v(" "),_c('div',{staticClass:"about_map_wrap"},[_c('img',{attrs:{"src":__webpack_require__("aKrY"),"height":"100%","width":"100%","alt":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "igzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comWrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"comItemWrap"},[_c('div',{staticClass:"comItemTiitle"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"comItemContent",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jAAr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/com1.cad2564.jpg";

/***/ }),

/***/ "jIYH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jvdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeWrap"},[_c('div',{staticClass:"pageBgSty"},[_c('div',{staticClass:"pageTitle"},[_vm._v("鑫安智能")]),_vm._v(" "),_c('div',{staticClass:"pageTitleTips"},[_vm._v("智能物联和智慧环保领域国内领先的解决方案服务商")])]),_vm._v(" "),_c('div',{staticClass:"contentWrap"},[_c('div',{staticClass:"con_title"},[_vm._v("解决方案")]),_vm._v(" "),_c('div',{staticClass:"con_inner"},[_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap"},[_c('img',{staticClass:"imgsty",attrs:{"src":__webpack_require__("o0D/"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("AI环保定制方案")]),_vm._v(" "),_c('div',{staticClass:"tipsContent"},[_c('div',{staticClass:"tipsConTitle"},[_vm._v("AI硬件产品定制开发")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("AI软件产品定制开发")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("AI算法定制开发")])])]),_vm._v(" "),_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap"},[_c('img',{staticClass:"imgsty",attrs:{"src":__webpack_require__("Tvie"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("AI扬尘监测方案")]),_vm._v(" "),_c('div',{staticClass:"tipsContent"},[_c('div',{staticClass:"tipsConTitle"},[_vm._v("扬尘指标监测")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("高清音视频监测")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("扬尘算法识别")])])]),_vm._v(" "),_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap"},[_c('img',{staticClass:"imgsty",attrs:{"src":__webpack_require__("Ukqi"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("AI异味监测方案")]),_vm._v(" "),_c('div',{staticClass:"tipsContent"},[_c('div',{staticClass:"tipsConTitle"},[_vm._v("异味指标监测")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("大气指纹分析溯源")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("异味算法识别")])])]),_vm._v(" "),_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap"},[_c('img',{staticClass:"imgsty",attrs:{"src":__webpack_require__("Aoun"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("空天地一体化监测方案")]),_vm._v(" "),_c('div',{staticClass:"tipsContent"},[_c('div',{staticClass:"tipsConTitle"},[_vm._v("多模态全场景产品定制")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("多源数据接入")]),_vm._v(" "),_c('div',{staticClass:"tipsConTitle"},[_vm._v("实时交互功能")])])])])]),_vm._v(" "),_c('div',{staticClass:"contentWrap"},[_c('div',{staticClass:"con_title"},[_vm._v("产品中心")]),_vm._v(" "),_c('div',{staticClass:"con_inner"},[_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap1"},[_c('img',{staticClass:"imgsty1",staticStyle:{"height":"200px"},attrs:{"src":__webpack_require__("7+Nz"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("固定式")])]),_vm._v(" "),_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap1"},[_c('img',{staticClass:"imgsty1",staticStyle:{"height":"125px"},attrs:{"src":__webpack_require__("HV4J"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("车载式")])]),_vm._v(" "),_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap1"},[_c('img',{staticClass:"imgsty1",staticStyle:{"height":"200px"},attrs:{"src":__webpack_require__("CNw4"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("便携式")])]),_vm._v(" "),_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap1"},[_c('img',{staticClass:"imgsty1",attrs:{"src":__webpack_require__("9HGo"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("无人机机载式")])]),_vm._v(" "),_c('div',{staticClass:"tips_wrap"},[_c('div',{staticClass:"imgWrap1"},[_c('img',{staticClass:"imgsty1",attrs:{"src":__webpack_require__("WW92"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tipsTitle"},[_vm._v("信息化软件")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l7y+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/com4.ec09dcc.jpg";

/***/ }),

/***/ "mEum":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {}, data: function data() {
    return {};
  }
});

/***/ }),

/***/ "o0D/":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "oh/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      isshow: ""
    };
  },
  created: function created() {},

  methods: {
    toMiit: function toMiit() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    }
  },
  watch: {}
});

/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rP+y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/com3.449458b.jpg";

/***/ }),

/***/ "t3m8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header_vue__ = __webpack_require__("hxP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_footer_vue__ = __webpack_require__("dQCR");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      firstPageMsg: {}

    };
  },
  created: function created() {},

  methods: {},
  components: {
    'e-footer': __WEBPACK_IMPORTED_MODULE_1__components_footer_footer_vue__["a" /* default */],
    'e-header': __WEBPACK_IMPORTED_MODULE_0__components_header_header_vue__["a" /* default */]
  },
  watch: {
    //使用watch 监听$router的变化
    $route: function $route(to, from) {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),

/***/ "w/Kr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/building.a14de20.png";

/***/ }),

/***/ "x+S9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: [],
  data: function data() {
    return {
      info: "",
      list: [{
        title: "指标因子",
        content: "标准六参/七参：PM2.5、PM10、SO2、NO2、CO、O3、TVOC<br>" + "气象类型：微气象五参(风速、风向、温度、湿度、气压)、噪声<br>"
      }, {
        title: "应用场景",
        content: "固定式、车载式、便携式手提箱、无人机机载"
      }, {
        title: "方案内容",
        content: "建设基于多种感知技术、覆盖多种应用场景、多项数据融合，实时交互分析研判指挥治理的环境空气质量监测网络。<br>" + "实现秒级数据和米级范围监测采集、智能化数据分析、多证据耦合分析研判，精准判断污染事件特性，多级预警告警处理机制，做到精准溯源、全自动流程治理。最终达到区域环境空气质量提升的目的。"
      }]
    };
  },
  created: function created() {},

  components: {},
  methods: {}
});

/***/ }),

/***/ "xlH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  created: function created() {},

  components: {},
  methods: {},
  watch: {}
});

/***/ }),

/***/ "zKIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("xlH+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_370d88fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("jvdF");
function injectStyle (ssrContext) {
  __webpack_require__("jIYH")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_370d88fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zjiE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_com0__ = __webpack_require__("3F6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_com1__ = __webpack_require__("ETTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_com2__ = __webpack_require__("KNS7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_com3__ = __webpack_require__("OT2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_com4__ = __webpack_require__("5E5l");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    com0: __WEBPACK_IMPORTED_MODULE_0__components_com0__["a" /* default */], com1: __WEBPACK_IMPORTED_MODULE_1__components_com1__["a" /* default */], com2: __WEBPACK_IMPORTED_MODULE_2__components_com2__["a" /* default */], com3: __WEBPACK_IMPORTED_MODULE_3__components_com3__["a" /* default */], com4: __WEBPACK_IMPORTED_MODULE_4__components_com4__["a" /* default */]
  },
  data: function data() {
    return {
      activeIndex: 0,
      currentCom: "com0",
      list: ["AI环保定制方案", "环境空气质<br>量监测方案", "恶臭监测方案", "扬尘监测方案", "温室气体<br>监测方案"]
    };
  },

  methods: {
    handleClick: function handleClick(index) {
      this.activeIndex = index;
      this.currentCom = "com" + index;
    }
  },
  watch: {}
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4a248222ce26dae04ae5.js